<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center">
      <b-col cols="12" md="4" >
        <font-awesome-icon :icon="['fas', 'check-circle']" class="text-success my-auto success-icon"></font-awesome-icon>
        <h3 class="font-weight-bolder mt-3">{{msgTitle}}</h3>
        <p class="" style="margin-bottom: 55px">{{msgDesc}}</p>
        <p class="" style="margin-bottom: 55px" v-if="isSuccess">{{getUser.data.type===1?`${getUser.data.subscription.recurring?'Next Billing Period:':'Your Membership ends:'} ${moment(getUser.data.subscription.end_date)}`:''}}</p>
        <a class="btn btn-primary btn-block" :href="getFromApps?'musicverse://transaction_done?price=' + this.netPrice:'/#/home'" >Continue</a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment'

export default {
  name: "SubscriptionSuccessPage",
  data() {
    return {
      msgCredit:'',
      lastCredit:0,
      netPrice:0,
      orderId:0,
      currency:'USD',
      isSuccess: false,
      msgTitle:'Payment is in Confirmation',
      msgDesc:'Thank you for partnering with MusicVerse. Please wait while we\'re confirming the payment',
      paymentPendingStatus:'',
      intervalCheck:null
    }
  },
  async mounted(){
    if(this.subscriptionTrxData!==''){
      this.netPrice = this.subscriptionTrxData.price;
      let resp = {data:''};
      let pending = false;
      let error = false;
      if(['gcash','grab_pay'].includes(this.subscriptionTrxData.paymentMethod)){
        this.setLoading();
        resp = await this.requestConfirmPaymentSubscriptionPayMongo({
          source_id:this.subscriptionTrxData.session_id
        });
        if(this.getStatus == 200){
          pending = !resp.success;

        }else{
          error = this.getStatus!=200 && this.getErrorCode=='error-paymongo-confirm'
          pending = true;
          resp = {data:''};
        }
        if(pending){
          this.setPaymentPending("1");
        }
        this.unsetLoading();
      }
      if(!!resp){
        if(!pending){
          await this.requestDetailUser();
          window.fbq('track', 'Subscribe', {
            value: this.subscriptionTrxData.price,
            currency: this.subscriptionTrxData.currency,
            predicted_ltv: this.subscriptionTrxData.price,
            content_category: 'premium',
          })
          this.removePaymentDataSubscription();
          this.isSuccess = true;
          this.msgTitle = 'Payment Successful!'
          this.msgDesc = 'Thank you for partnering with MusicVerse'
        }
      }else{
        this.setPaymentError({
          msg:this.getMessage,
          type:'subscription',
        })
        this.$router.push({name:'TransactionFailedPage'});
      }
    }else{
      this.$router.push({ name: 'HomePage' });
    }

  },
  watch:{
    paymentPending: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.paymentPendingStatus = val;
        if(this.paymentPendingStatus == "1"){
          const _this = this;
          this.intervalCheck = setInterval(function(){
            _this.intervalCheckPayment();
          },5000);
        }else{
          if(this.getUser.data.type == 0){
            this.removePaymentPending();
          }
        }
      }
    },
  },
  computed:{
    ...mapGetters('PaymentModule', ['subscriptionTrxData','paymentPending','intervalCheckPending']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser','getFromApps']),
  },
  methods:{
    ...mapActions('PaymentModule', ['requestConfirmPaymentSubscription','requestConfirmPaymentSubscriptionPayMongo',
      'removePaymentDataSubscription','setPaymentError','setPaymentPending','setIntervalCheckPending','removeIntervalCheckPending',
      'removePaymentPending','removePaymentError']),
    ...mapActions('AuthModule',['requestDetailUser']),
    ...mapActions('NotificationModule',['setLoading','unsetLoading']),
    moment: function (date) {
      return moment(date).format('DD MMMM YYYY');
    },
    goToHome(){
      this.$router.push({ name: 'HomePage' });
    },
    async intervalCheckPayment(){
      const resp = await this.requestConfirmPaymentSubscriptionPayMongo({
        source_id:this.subscriptionTrxData.session_id
      });
      const error = this.getStatus!=200 && this.getErrorCode=='error-paymongo-confirm'
      if(!error && resp.success){
        clearInterval(this.intervalCheck)
        window.fbq('track', 'Subscribe', {
          value: this.subscriptionTrxData.price,
          currency: this.subscriptionTrxData.currency,
          predicted_ltv: this.subscriptionTrxData.price,
          content_category: 'premium',
        })
        this.isSuccess = true;
        this.msgTitle = 'Payment Successful!'
        this.msgDesc = 'Thank you for partnering with MusicVerse'
        this.removeIntervalCheckPending();
        this.removePaymentDataSubscription();
        this.removePaymentError();
        this.removePaymentPending();
        await this.requestDetailUser();
      }else{
        let intv = 0;
        if(this.intervalCheckPending !== ''){
          intv = Number(this.intervalCheckPending);
        }
        if(intv<=12){
          this.setIntervalCheckPending(intv+1);
        }else{
          clearInterval(this.intervalCheck);
          this.removeIntervalCheckPending();
          this.removePaymentDataSubscription();
          this.removePaymentError();
          this.removePaymentPending();
        }
      }
    },
  },
  components: {
    VueCustomTooltip
  },
}
</script>

<style scoped>
  .cursor-pointer{
    cursor: pointer;
  }
  .success-icon{
    font-size: 134px
  }
  .credit-text{
    font-size: 100px;
  }
  .copy-icon-link{
    right: -40px;top: 25px;
  }
  .copy-icon{
    width: 40px; height: 50px; margin:auto
  }
  .social-item img{
    width: 45px;
  }
  @media screen and (max-width: 767.98px) {
    .credit-text{
      font-size: 50px;
    }
    .copy-icon-link{
      right: 0;
      top: 12px;
    }
    .copy-icon{
      width: 20px; height: 30px; margin:auto
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/SubscriptionSuccess.vue